import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import { EventDetail } from 'app/events/events';

@Injectable({ providedIn: 'root' })
export class CalendarEventDetailsService {
    baseUrl: string;

    constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this.baseUrl = baseUrl + 'api/TCalEventDetails';
    }

    getAllCalendarEventDetails(): Observable<EventDetail[]> {
        return this.http.get<EventDetail[]>(this.baseUrl);
    }

    getCalendarEventDetailsById(eventId: number): Observable<EventDetail[]> {
        const params = new HttpParams().set('eventId', eventId.toString());
        return this.http.get<EventDetail[]>(`${this.baseUrl}/EventDetails`, { params });
    }

    getCalendarEventDetailById(id: number): Observable<EventDetail> {
        return this.http.get<EventDetail>(`${this.baseUrl}/${id}`);
    }

    createCalendarEventDetail(params: EventDetail): Observable<EventDetail> {
        return this.http.post<any>(this.baseUrl, params);
    }

    updateCalendarEventDetail(id: number, calEvent: EventDetail): Observable<any> {
        return this.http.put(`${this.baseUrl}/${id}`, calEvent);
    }

    deleteCalendarEventDetail(id: number): Observable<EventDetail> {
        return this.http.delete<EventDetail>(`${this.baseUrl}/${id}`);
    }
}
